// Conditionally enforce availability filter based on whether other filters are selected
(function () {
  "use strict";

  // Function to conditionally apply or remove the availability filter
  function conditionallyApplyAvailabilityFilter(url) {
    const urlObj = new URL(url, window.location.origin);
    const params = urlObj.searchParams;
    let hasOtherFilters = false;

    // Check for any other filters, excluding the availability one itself
    for (const key of params.keys()) {
      if (
        key.startsWith("filter.") &&
        key !== "filter.v.availability" &&
        key !== "filter.v.option.מידה"
      ) {
        hasOtherFilters = true;
        break;
      }
    }

    if (hasOtherFilters) {
      // If other filters exist, make sure the availability filter is set
      params.set("filter.v.availability", "1");
    } else {
      // If no other filters exist, make sure the availability filter is removed
      params.delete("filter.v.availability");
    }

    return urlObj.toString();
  }

  // Keep history URL and fetch request in sync before the theme handles facet updates
  document.addEventListener(
    "facet:update",
    function (e) {
      try {
        if (!e.detail || !e.detail.url) return;
        const original =
          e.detail.url instanceof URL ? e.detail.url.toString() : e.detail.url;
        const adjusted = conditionallyApplyAvailabilityFilter(original);
        if (adjusted !== original) {
          e.detail.url = new URL(adjusted, window.location.origin);
        }
      } catch (err) {
        // no-op
      }
    },
    true
  );

  // Override fetch to intercept filter requests
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    if (args[0]) {
      if (typeof args[0] === "string" && args[0].includes("/collections/")) {
        args[0] = conditionallyApplyAvailabilityFilter(args[0]);
      } else if (
        args[0] instanceof URL &&
        args[0].toString().includes("/collections/")
      ) {
        const adjusted = conditionallyApplyAvailabilityFilter(
          args[0].toString()
        );
        args[0] = new URL(adjusted, window.location.origin);
      }
    }
    return originalFetch.apply(this, args);
  };

  // On initial page load, ensure URL includes availability when other filters exist
  function ensureInitialAvailability() {
    try {
      const adjusted = conditionallyApplyAvailabilityFilter(
        window.location.href
      );
      if (adjusted !== window.location.href) {
        const facetsForm = document.querySelector("facets-form[section-id]");
        if (facetsForm) {
          const sectionId = facetsForm.getAttribute("section-id");
          const url = new URL(adjusted, window.location.origin);
          url.searchParams.set("section_id", sectionId);
          document.dispatchEvent(
            new CustomEvent("facet:update", { bubbles: true, detail: { url } })
          );
        } else {
          history.replaceState({}, "", adjusted);
        }
      }
    } catch (err) {
      // no-op
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureInitialAvailability, {
      once: true,
    });
  } else {
    ensureInitialAvailability();
  }

  // Handle facet form submissions
  document.addEventListener("DOMContentLoaded", function () {
    // Handle clear all links and last filter removal
    document.addEventListener("click", function (e) {
      const removableFacetLink = e.target.closest(".removable-facet a");

      if (removableFacetLink) {
        const totalFacets =
          document.querySelectorAll(".removable-facet").length;
        if (totalFacets === 1) {
          e.preventDefault();
          // If it's the last filter, treat it like 'Clear All' by going to the base URL
          const baseUrl = window.location.href.split("?")[0];
          window.location.href = baseUrl;
          return;
        }
      }

      if (e.target.closest("[data-clear-all]")) {
        e.preventDefault();
        const link = e.target.closest("a");
        if (link && link.href) {
          window.location.href = conditionallyApplyAvailabilityFilter(
            link.href
          );
        }
      }
    });
  });

  // Handle browser navigation
  window.addEventListener("popstate", function (e) {
    // On popstate, re-evaluate the URL to ensure filter state is correct
    const newUrl = conditionallyApplyAvailabilityFilter(window.location.href);
    if (window.location.href !== newUrl) {
      history.replaceState({}, "", newUrl);
      // The browser won't re-trigger content load on replaceState, so we might need to do it manually if content is out of sync.
      // However, Dawn theme's facet logic should handle this on popstate.
    }
  });
})();
